import React from 'react';
import styled from 'styled-components';
import { FiEdit3, FiCheck } from 'react-icons/fi';
import { useMenuPreferences } from '../../contexts/MenuPreferencesContext';

const ToggleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 12px;
  background: ${props => props.$active ? '#4CAF50' : 'transparent'};
  border: 1px solid ${props => props.$active ? '#4CAF50' : '#555'};
  border-radius: 6px;
  color: ${props => props.$active ? '#fff' : '#aaa'};
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
  margin: 10px 15px;
  width: ${props => props.$menuMinimized ? '40px' : 'calc(100% - 30px)'};

  &:hover {
    background: ${props => props.$active ? '#45a049' : 'rgba(255, 255, 255, 0.05)'};
    border-color: ${props => props.$active ? '#45a049' : '#777'};
    color: ${props => props.$active ? '#fff' : '#fff'};
  }

  svg {
    font-size: 16px;
  }

  span {
    display: ${props => props.$menuMinimized ? 'none' : 'block'};
    font-weight: 500;
  }
`;

const SavingIndicator = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  margin: 0 15px 10px;
  background: rgba(255, 193, 7, 0.1);
  border: 1px solid rgba(255, 193, 7, 0.3);
  border-radius: 6px;
  color: #FFC107;
  font-size: 12px;
  
  .spinner {
    width: 12px;
    height: 12px;
    border: 2px solid rgba(255, 193, 7, 0.3);
    border-top-color: #FFC107;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }

  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`;

export default function EditModeToggle({ menuMinimized }) {
  const { editMode, toggleEditMode, saving } = useMenuPreferences();

  return (
    <>
      <ToggleButton
        onClick={toggleEditMode}
        $active={editMode}
        $menuMinimized={menuMinimized}
        title={editMode ? 'Sair do modo de edição' : 'Editar menu'}
      >
        {editMode ? <FiCheck /> : <FiEdit3 />}
        <span>{editMode ? 'Concluir' : 'Editar Menu'}</span>
      </ToggleButton>
      
      {saving && !menuMinimized && (
        <SavingIndicator>
          <div className="spinner" />
          <span>Salvando...</span>
        </SavingIndicator>
      )}
    </>
  );
}
